import React from 'react'

const Video = () => {
  return(
    <iframe className="youtube" width="560" height="315" src="https://www.youtube.com/embed/FKZAzDgcJXY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  )
}

export default Video;